export * from './src/bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';
